import { render, staticRenderFns } from "./normalInfo.vue?vue&type=template&id=d3b290f6&scoped=true&"
import script from "./normalInfo.vue?vue&type=script&lang=js&"
export * from "./normalInfo.vue?vue&type=script&lang=js&"
import style0 from "./normalInfo.vue?vue&type=style&index=0&id=d3b290f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b290f6",
  null
  
)

export default component.exports